<h1 mat-dialog-title>{{ consent.title | translate }}</h1>
<div
  mat-dialog-content
  scroll-monitor
  (onScrollToBottom)="onScrollToBottom()"
  #content
>
  <section>
    <div class="terms">
      <p class="text-content" [innerHtml]="consent.text | translate"></p>
      <p *ngIf="consent.url">
        <a href="{{ consent.url }}">Read full details here.</a>
      </p>
    </div>
  </section>
</div>
<mat-divider class="divider"></mat-divider>
<mat-dialog-actions
  class="button-container"
  fxLayout="row"
  fxLayoutAlign="space-between center"
>
  <button mat-stroked-button [mat-dialog-close]="false">
    {{ 'common.cancel' | translate }}
  </button>
</mat-dialog-actions>
